export default {"src":"/_next/static/media/LandingAnimationManHoopcare.639abfa4.gif","height":673,"width":673,"blurWidth":0,"blurHeight":0};